import type { ComponentProps } from "react";

type Props = {
  size?: number;
} & ComponentProps<"svg">;

export const OriginalManagerIcon = ({
  color = "currentColor",
  size = 16,
  ...props
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 8C8 8 7.07304 7.07495 5.8 7.07495M5.8 7.07495C4.52696 7.07495 3.30606 7.58066 2.40589 8.48084C1.50571 9.38101 1 10.6019 1 11.875M5.8 7.07495C7.45685 7.07495 8.8 5.73181 8.8 4.07495C8.8 2.4181 7.45685 1.07495 5.8 1.07495C4.14315 1.07495 2.8 2.4181 2.8 4.07495C2.8 5.73181 4.14315 7.07495 5.8 7.07495ZM9.11111 10.7V9.49995C9.11111 9.10213 9.25744 8.7206 9.51791 8.43929C9.77837 8.15799 10.1316 7.99995 10.5 7.99995C10.8684 7.99995 11.2216 8.15799 11.4821 8.43929C11.7426 8.7206 11.8889 9.10213 11.8889 9.49995V10.7M8.55556 10.7H12.4444C12.7513 10.7 13 10.9686 13 11.3V12.5C13 12.8313 12.7513 13.1 12.4444 13.1H8.55556C8.24873 13.1 8 12.8313 8 12.5V11.3C8 10.9686 8.24873 10.7 8.55556 10.7Z"
        stroke={color}
        strokeWidth="1.33"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
